
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9]{2,}[.][a-zA-Z0-9]{1,5}((?:[.]{1}[a-zA-Z0-9]{1,5})?)*$/;
export const USER_NAME = /^[a-zA-Z0-9]*$/;
export const DAY_OF_WEEK = [
  {displayText: 'Mon', key: 'MO'},
  {displayText: 'Tue', key: 'TU'},
  {displayText: 'Wed', key: 'WE'},
  {displayText: 'Thu', key: 'TH'},
  {displayText: 'Fri', key: 'FR'},
  {displayText: 'Sat', key: 'SA'},
  {displayText: 'Sun', key: 'SU'}
];
export enum AuthType {
  login = 'LOGIN',
  register = 'REGISTER',
  forgot_password = 'FORGOT_PASSWORD',
  reset_password = 'RESET_PASSWORD',
}

export enum BUTTON_NAME {
  OK = 'ok',
  CANCEL = 'cancel',
  REPORT = 'report',
  DELETE = 'delete',
  CHECK_IN = 'checkIn'
}

export enum EVENT_RECURSIVE_OPTIONS {
  THIS = 0,
  FOLLOWING = 1,
  ALL = 2
}

export enum HttpStatus {
  OK = 200,
  Created = 201,
  Accepted = 202,
  NonAuthoritativeInformation = 203,
  NotContent = 204,
  ResetContent = 205,
  PartialContent = 206,
  MultiStatus = 207,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
}

export enum TypeRoom {
  NORMAL = 0,
  VIP = 1,
}
export enum EVENT_STATUS {
  CANCEL = 'CANCEL',
  CHECK_IN = 'CHECK_IN',
  NEW = 'NEW'
}




// WEBPACK FOOTER //
// /app/src/app/common/constants.ts